"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/material/styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _lodash = _interopRequireDefault(require("lodash.clonedeep"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _Theme = _interopRequireDefault(require("./Theme.json"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ThemeProvider = /*#__PURE__*/(0, _react.memo)(({
  children,
  orgTheme
}) => {
  /**
   * Users might have a preference for light or dark mode that they've set through their operating system
   */
  const prefersDarkMode = (0, _useMediaQuery.default)("(prefers-color-scheme: dark)");

  /**
   * Create the Material theme object to pass to 
   * Material UI's theme provider — this will 
   * theme all the Material app sections.
   */
  const muiTheme = (0, _react.useMemo)(() => {
    /**
     * We must clone so we don't mutate the original theme 
     * definition below, as we will need the original again 
     * later e.g. if the org changes and we are switching to 
     * a different accent colour
     */
    const theme = (0, _lodash.default)(_Theme.default.HOPSApp);

    /**
     * Apply the org's custom accent colours, when applicable
     */
    if (orgTheme?.AccentColour) {
      theme.palette.primary.main = orgTheme.AccentColour;
    }
    if (orgTheme?.AccentColourSecondary) {
      theme.palette.secondary.main = orgTheme.AccentColourSecondary;
    }

    /**
     * Apply the org's custom font, when applicable
     */
    if (orgTheme?.FontFamily) {
      theme.typography.fontFamily = `"${orgTheme?.FontFamily}", sans-serif, serif`;
    }

    /**
     * Apply dark mode, when applicable
     */
    if (orgTheme?.Mode === "auto") {
      theme.palette.mode = prefersDarkMode ? "dark" : "light";
    } else if (orgTheme?.Mode) {
      theme.palette.mode = orgTheme.Mode;
    }

    /**
     * Add Dark Mode Overrides
     */
    if (theme.palette.mode === "dark") {
      theme.palette = {
        ...theme.palette,
        ..._Theme.default.HOPSAppDark.palette
      };
    }

    /**
     * Create the Material theme now
     */
    return (0, _styles.createTheme)(theme);
  }, [orgTheme, prefersDarkMode]);

  /**
   * When the theme object changes, we need to 
   * reflect those changes onto the CSS variables 
   * that we use to theme some of our components
   */
  (0, _react.useEffect)(() => {
    const cssVars = {
      "--accent-color": muiTheme.palette.primary.main,
      "--base-color": muiTheme.palette.background.default,
      "--divider-color": muiTheme.palette.divider,
      "--paper-color": muiTheme.palette.background.paper,
      "--typography-color": muiTheme.palette.text.main
    };
    for (const cssVar of Object.entries(cssVars)) {
      const [v, value] = cssVar;
      document.documentElement.style.setProperty(v, value);
    }
  }, [muiTheme]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ThemeProvider, {
    theme: muiTheme,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHelmet.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "theme-color",
        content: muiTheme.palette.primary.main
      })
    })]
  });
});
var _default = exports.default = ThemeProvider;